module.exports = __webpack_public_path__ + "img/PD1504998080402030592.2c7ba4e7.png";